import { StatusLabels } from '@plugins/faq-lib/types';

type StatusColors =
  | 'color_active'
  | 'color_potentially_answered'
  | 'color_answered';

export const STATUS_COLOR: Record<StatusLabels, StatusColors> = {
  label_active: 'color_active',
  label_answered: 'color_answered',
  label_potentially_answered: 'color_potentially_answered',
};
